module.exports = __webpack_public_path__ + "img/no_project_data.60ba2dc7.png";